import React from 'react';

import { MASTERY_LEVEL_TO_LABEL_MAPPER } from '../../constants';
import StudentProgressBox from '../StudentProgressBox';
import styles from './style.module.scss';

const StudentProgress = ({ students }) => {
  return (
    <>
      <header>
        <div>
          <h3 className={styles.heading}>Students Progress</h3>
        </div>
      </header>
      <div className={styles.progressDashboard}>
        {students.map((studentProgress, index) => {
          return (
            <StudentProgressBox
              key={`studentprogress-${index}`}
              name={studentProgress.student_name}
              status={
                MASTERY_LEVEL_TO_LABEL_MAPPER[studentProgress.tag_description]
              }
              grade={studentProgress.student_work_score?.toLowerCase()}
              isPublished={['complete', 'revise'].includes(
                studentProgress.tracker_score_student_status
              )}
            />
          );
        })}
      </div>
    </>
  );
};

export default StudentProgress;
